//Material
import { Grid } from "@mui/material";
//Interfaces and Types
import { IUserPhonesProps } from "../../types/UserProfile";

const TAILWIND_CSS_STYLE =
	"!text-[17px] !font-['PTSansProNarrow',sans-serif] !pl-[16px] !text-[var(--text-color)] !border-solid !border-0 !border-black";

export default function UserProfileDetailInformation({
	name,
	isLoading,
	componentLoadingTrue: ComponentTrue,
	componentLoadingFalse: ComponentFalse,
}: Readonly<IUserPhonesProps>) {
	return (
		<Grid container item xs={12} direction="row" alignContent={"center"} alignItems={"center"} columnSpacing={2}>
			<Grid item xs={2} className={TAILWIND_CSS_STYLE}>
				{name}
			</Grid>
			<Grid item xs={true} className="!max-w-[600px]">
				{isLoading ? ComponentTrue : ComponentFalse}
			</Grid>
		</Grid>
	);
}
